import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Column, Lookup } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { ButtonItem, FormRef, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import IUsager from "../../models/IUsager";
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import Guid from "../../models/Guid";
import GestionEntreprises from '../gestion-entreprises/gestion-entreprises';
import GestionPermission from '../gestion-permissions/gestion-permission';

interface IGestionUsagersProps {
  isModeSelection?: boolean,
}

export default function GestionUsagers({ isModeSelection }: IGestionUsagersProps) {
  const clientFormDataSource = useCustomDataSource<IUsager, IUsager>({
    path: "usager",
    primaryKey: "idUsager",
  });
  const { setMainForm, selectedDataRow: selectedUsager, mode, setSelectedDataRow, setMode, isFieldModifier, setIsFieldModifier } = clientFormDataSource;
  const { editorOptions: permissionsEditorOption, PopupGestion: PopupGestionPermission } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'permissions',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPermission", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, titre: "Gestion d'une permission"
  });
  const { editorOptions: entrepriseParDefautEditorOption, PopupGestion: PopupGestionEntrepriseParDefaut } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'entreprise',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idEntrepriseDefault", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, titre: "Gestion d'une entreprise par défaut"
  });

  const { editorOptions: permissionEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "droitacces", showClear: mode !== Mode.Lecture });
  const [password, passwordActive] = useState(false);
  const formRef = useRef<FormRef>(null);

  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IUsager) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }

  //memos
  const nomOptions = useMemo(() => {
    return { maxLength: 50 }
  }, []);
  const codeUsagerOptions = useMemo(() => {
    return { minLength: 2, maxLength: 20 }
  }, []);
  const btnCodeUsagerOptions = useMemo(() => {
    return {
      text: "Entrer ou réinitialiser le mot de passe", maxLength: 300,
      onClick: () => {
        passwordActive(prevState => !prevState)
      },
      disabled: mode === Mode.Lecture
    }
  }, [mode]);
  const passwordOptions = useMemo(() => {
    return { mode: "password", maxLength: 100 }
  }, []);
  const emailOptions = useMemo(() => {
    return { maxLength: 100 }
  }, []);
  const infosCarteCreditOptions = useMemo(() => {
    return { text: "Peut voir les informations de carte de crédit" }
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Actif" }
  }, []);
  const languesEditorOption = useMemo(() => {
    return {
      items: [
        { value: "fr", text: "Français" },
        { value: "en", text: "English" }
      ],
      valueExpr: "value",
      displayExpr: "text",
      searchEnabled: false,
      showClearButton: false
    }
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture)
      formRef.current?.instance().getEditor("nom")?.focus();
  }, [mode])

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IUsager) => {
      return { ...prev, [e]: item.id }
    })
  }

  console.log(selectedUsager)
  return (
    <FormListBase data={clientFormDataSource}>
      <FormListBaseGrid
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture)
        }}>
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false} />
        <Column key={"grid-col-code"} dataField={"codeUsager"} caption="Code" allowHiding={false} />
        <Column key={"grid-col-email"} dataField={"email"} caption="Courriel" allowHiding={false} />
        <Column key={"grid-col-permissions"} dataField={"idDroitAcces"} caption="Permissions" allowHiding={false}>
          <Lookup {...permissionEditorOptions} />
        </Column>
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedUsager?.nom || ''} ${selectedUsager?.prenom || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} removeBlocked={true} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
        <TabItem title="Informations">
          <PopupGestionEntrepriseParDefaut
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idEntrepriseDefault", data.idEntrepriseDefault);
            }}
          >
            <GestionEntreprises isModeSelection={true} />
          </PopupGestionEntrepriseParDefaut>
          <PopupGestionPermission
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPermission", data.idPermission);
            }}
          >
            <GestionPermission isModeSelection={true} />
          </PopupGestionPermission>
          {/* <div style={{ display: "flex" }}> */}
          {/* <div style={{ width: "100%" }}> */}
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedUsager || {} as IUsager} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={(e) => setIsFieldModifier(true)}>
            <GroupItem colCount={2}>
              <GroupItem>
                <SimpleItem key={"frm-nom"} dataField={"nom"} editorOptions={nomOptions} />
                <SimpleItem key={"frm-prenom"} dataField={"prenom"} editorOptions={nomOptions}>
                  <Label text={"Prénom"} />
                </SimpleItem>
                <SimpleItem key={"frm-code-usager"} dataField={"codeUsager"} editorOptions={codeUsagerOptions}>
                  <Label text={"Code usager"} />
                </SimpleItem>
                <ButtonItem
                  key={"frm-btn-code-usager"} buttonOptions={btnCodeUsagerOptions}
                />
                {password &&
                  <SimpleItem key={"frm-password"} dataField={"motDePasse"} editorOptions={passwordOptions}>
                    <Label text={"Mot de passe"} />
                  </SimpleItem>
                }
                <SimpleItem key={"frm-email"} dataField={"email"} editorOptions={emailOptions}>
                  <Label text={"Courriel"} />
                </SimpleItem>
                <SimpleItem key={"frm-permissions"} dataField={"permissions"} editorOptions={permissionsEditorOption} />
                <SimpleItem
                  key={"frm-entreprise-default"}
                  editorType={"dxSelectBox"}
                  dataField={"idEntrepriseDefault"}
                  editorOptions={entrepriseParDefautEditorOption}
                >
                  <Label text={"Entreprise par défaut"} />
                </SimpleItem>
                <SimpleItem key={"frm-langue"} dataField={"langue"} editorType={"dxSelectBox"} editorOptions={languesEditorOption} />
                <SimpleItem key={"frm-infos-carte-credit"} dataField={"voirInfosCarteCredit"} editorType={"dxCheckBox"} editorOptions={infosCarteCreditOptions}>
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption={"Statut"}>
                <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"} editorOptions={actifOptions}>
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>
            </GroupItem>
          </Form>
          {/* </div> */}
          {/* <div style={{ width: "60%" }}>
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedUsager || {} as IUsager} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <GroupItem caption={"Statut"}>
                  <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"} editorOptions={actifOptions}>
                    <Label visible={false} />
                  </SimpleItem>
                </GroupItem>
              </Form>
            </div> */}
          {/* </div> */}
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedUsager || {} as IUsager} /></TabItem>
      </FormListBaseTab> : null}
    </FormListBase>
  );
}